'use strict'

let noTranslateTerms = null

export default () => {

    if(!noTranslateTerms) noTranslateTerms = []
    return noTranslateTerms

}